import { RegisterScore } from './RegisterScore';
export default RegisterScore;
